import React, { useEffect } from "react";
import { useState } from "react";
import contexp from "../../assets/contenido/ContExp.png";
import { ContentCard } from "../Content/Cards/ContentCard";
import style from "./ContentExp.module.css";
import img1 from "../../assets/contenido/cardcont1.png";
import img2 from "../../assets/contenido/cardcont2.png";
import img3 from "../../assets/contenido/cardcont3.png";

export const ContentExp = () => {
  const [content, setContent] = useState({
    title: " ¿Como se hacen las velas?",
    author: " Arlene McCoy",
    text: "Physical space is often conceived in three linear dimensions, although modern physicists usually consider it, with time, to be part of a boundless four-dimensional continuum known as spacetime. The concept of space is considered to be of fundamental importance to an understanding of the physical universe. However, disagreement continues between philosophers over whether it is itself an entity, a relationship between entities, or part of a conceptual framework. Physical space is often conceived in three linear dimensions, although modern physicists usually consider it, with time, to be part of a boundless four-dimensional continuum known as spacetime. The concept of space is considered to be of fundamental importance to an understanding of the physical universe. However, disagreement continues between philosophers over whether it is itself an entity, a relationship between entities, or part of a conceptual framework.Physical space is often conceived in three linear dimensions, although modern physicists usually consider it, with time, to be part of a boundless four-dimensional continuum known as spacetime. The concept of space is considered to be of fundamental importance to an understanding of the physical universe. However, disagreement continues between philosophers over whether it is itself an entity, a relationship between entities, or part of a conceptual framework. Physical space is often conceived in three linear dimensions, although modern physicists usually consider it, with time, to be part of a boundless four-dimensional continuum known as spacetime. The concept of space is considered to be of fundamental importance to an understanding of the physical universe. However, disagreement continues between philosophers over whether it is itself an entity, a relationship between entities, or part of a conceptual framework.",
  });

  const article1 = {
    img: img1,
    text: "Maxwell's equations—the foundation of classical electromagnetism—describe light as a wave that moves with a characteristic velocity. The modern view is that light needs no medium of transmission, but Maxwell and his contemporaries were convinced that light waves were propagated in a medium...",
    title: `Las velas como regalo`,
    author: "unknown",
  };

  const article2 = {
    img: img2,
    text: "Maxwell's equations—the foundation of classical electromagnetism—describe light as a wave that moves with a characteristic velocity. The modern view is that light needs no medium of transmission, but Maxwell and his contemporaries were convinced that light waves were propagated in a medium...",
    title: "Velas como decoración",
    author: "unknown",
  };

  const article3 = {
    img: img3,
    text: "Maxwell's equations—the foundation of classical electromagnetism—describe light as a wave that moves with a characteristic velocity. The modern view is that light needs no medium of transmission, but Maxwell and his contemporaries were convinced that light waves were propagated in a medium...",
    title: "Como cortar tu mecha",
    author: "unknown",
  };

  let handler1 = () => {
    setContent({
      title: article1.title,
      text: article1.text,
      author: article1.author,
    });
    window.scrollTo(0, 200);
  };

  let handler2 = () => {
    setContent({
      title: article2.title,
      text: article2.text,
      author: article2.author,
    });
    window.scrollTo(0, 200);
  };

  let handler3 = () => {
    setContent({
      title: article3.title,
      text: article3.text,
      author: article3.author,
    });
    window.scrollTo(0, 200);
  };

  let url = window.location.href;
  let cardSelector = url[url.length - 1];

  useEffect(() => {
    cardSelector == 1 ? handler1() : "";
    cardSelector == 2 ? handler2() : "";
    cardSelector == 3 ? handler3() : "";
  }, [cardSelector]);

  return (
    <div className={style.container}>
      <img src={contexp} alt="banner" className={style.banner} />
      <div className={style.txtContainer}>
        <h1 className={style.title}> {content.title}</h1>
        <p className={style.author}> {content.author} </p>
        <p className={style.text}> {content.text} </p>
      </div>

      <div className={style.cardCont}>
        <div className={style.cardMov}>
          <ContentCard
            imagen={article1.img}
            title={article1.title}
            text={article1.text}
            action={handler1}
          >
            {" "}
          </ContentCard>
          <ContentCard
            imagen={article2.img}
            title={article2.title}
            text={article2.text}
            action={handler2}
          >
            {" "}
          </ContentCard>
          <ContentCard
            imagen={article3.img}
            title={article3.title}
            text={article3.text}
            action={handler3}
          >
            {" "}
          </ContentCard>
        </div>
      </div>
    </div>
  );
};
